const PageTitlePort = {
  add: function (app) {
    app.ports.updateTitle.subscribe((newText) => {
      document.getElementsByTagName("title")[0].innerHTML = newText;
    });
  },
};

module.exports = PageTitlePort;
